import { SettingsFieldSelect } from 'apps/builder/components/settings/modal/shared'
import { useDispatch } from 'react-redux'
import { TextArea } from 'components/Input/Input'
import { updateEntry } from 'apps/builder/store/actions/entries'

export const StaticTextField = ({
  guid,
  label,
  type,
  original_type_id,
  keyField,
}) => {
  const dispatch = useDispatch()

  const update = value => {
    dispatch(
      updateEntry({
        guid,
        label: value,
      })
    )
  }

  const inputProps = {
    value: label,
    placeholder: ' ',
    update: update,
    additionalClass: 'settings--inputs settings--static-text-input',
    label: 'Static Text',
  }

  return (
    <>
      <SettingsFieldSelect
        guid={guid}
        label={label}
        keyField={keyField}
        type={type}
      />

      <div className="settings--default-value">
        <TextArea {...inputProps} />
      </div>
    </>
  )
}
